// src/utils/avatar.ts
const LOCAL = [
  '/avatars/1.png','/avatars/2.png','/avatars/3.png','/avatars/4.png'
]

// 根据用户名生成“稳定随机”的头像（同一个用户名每次都是同一张）
export function pickAvatar(username: string) {
  if (!username) return LOCAL[Math.floor(Math.random()*LOCAL.length)]
  let h = 0; for (let i = 0; i < username.length; i++) h = (h*31 + username.charCodeAt(i)) >>> 0
  // return LOCAL[h % LOCAL.length]
  // 想用在线头像可换成 DiceBear：
  return `https://api.dicebear.com/7.x/adventurer-neutral/svg?seed=${encodeURIComponent(username)}`
}
